import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Highchart from "highcharts/highcharts";
import HighchartsVue from "highcharts-vue";
import timeLine from "highcharts/modules/timeline";
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'hDx1PZhilwb9WHNCH6O01rDHZRTFwBRA'
})

timeLine(Highchart);
Vue.use(HighchartsVue);
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.axios = axios



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
